import Vue from 'vue';
import store from './../../store';
import getlistentries from './getlistentries';

const PUTBULK_URL = '/api/v1/lists/';

// When the request succeeds
const successPutBulk = (response) => {
// TODO: uncomment and fix
// TODO: Reload list data? Or leave this to the view code to do???
  store.dispatch('getURLLookup', response.data);
  getlistentries(store.state.lists.listentries_list_id,
    store.state.lists.listentries_pageinfo.thispage_number,
    store.state.lists.listentries_pageinfo.pagesize,
    0);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedPutBulk = () => {
};

export default (listid, listarray, mode, callbackfunc) => {
  const axiosOptions = {
    timeout: 60000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const queryinfo = {
    urls: listarray,
  };
  // console.log(lines);
  const thisurl = `${PUTBULK_URL}${listid}/entries`;

  if (mode === 'add') {
    Vue.$http.post(thisurl, queryinfo, axiosOptions)
     .then((response) => {
       successPutBulk(response);
       callbackfunc(true);
     })
     .catch((error) => {
       failedPutBulk(error);
       callbackfunc(false);
     });
  }

  if (mode === 'delete') {
    axiosOptions.data = queryinfo;
    Vue.$http.delete(thisurl, axiosOptions)
     .then((response) => {
       successPutBulk(response);
       callbackfunc(true);
     })
     .catch((error) => {
       failedPutBulk(error);
       callbackfunc(false);
     });
  }

  if (mode === 'replace') {
    Vue.$http.put(thisurl, queryinfo, axiosOptions)
     .then((response) => {
       successPutBulk(response);
       callbackfunc(true);
     })
     .catch((error) => {
       failedPutBulk(error);
       callbackfunc(false);
     });
  }
};



// WEBPACK FOOTER //
// ./src/app/services/list/putbulklist.js